export const itemAvailabilityDataLocator = {
    itemavailability_items_available: 'itemavailability_items_available',
    itemavailability_items_unavailable_alert: 'itemavailability_items_unavailable_alert',
    itemavailability_items_unavailable_alert_expanded: 'itemavailability_items_unavailable_alert_expanded'
};
